import { render, staticRenderFns } from "./VideoArea.vue?vue&type=template&id=713fd258&"
import script from "./VideoArea.vue?vue&type=script&lang=js&"
export * from "./VideoArea.vue?vue&type=script&lang=js&"
import style0 from "./VideoArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports